export const GRID_COLUMNS_COUNT = [1, 2, 3];
